<template>
  <div>{{ $options.name }}</div>
</template>

<script>

export default {
  name: "Admin-Search-Claim",
  path: "claim",
  mounted() {
   this.$spark.$breadcrumbs(this.$options);
  }
};
</script>
